import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function ProductsCTA() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContact = () => {
    sessionStorage.setItem('scrollToContact', '1');
    navigate('/');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <section className="py-20 bg-[#F5F4F1]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="rounded-3xl bg-[#1B3F7A] p-12 flex flex-col md:flex-row items-center justify-between gap-8 relative overflow-hidden">
          {/* BG decoration */}
          <div className="absolute right-0 top-0 w-64 h-64 rounded-full bg-white/5 -translate-y-1/2 translate-x-1/4" />
          <div className="absolute right-20 bottom-0 w-40 h-40 rounded-full bg-white/5 translate-y-1/2" />

          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-3">
              {t('products.cta.title')}
            </h2>
            <p className="text-white/70 text-base leading-relaxed max-w-xl">
              {t('products.cta.desc')}
            </p>
          </div>

          <div className="relative z-10 flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button
              onClick={handleContact}
              className="px-8 py-3.5 bg-white text-[#1B3F7A] font-semibold rounded-full hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              {t('products.cta.btn1')}
            </button>
            <button
              type="button"
              onClick={handleGoHome}
              className="px-8 py-3.5 border border-white/40 text-white font-semibold rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              {t('products.cta.btn2')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
